module.exports = __webpack_public_path__ + "img/new_age_05.1cef367f.jpg";